module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/babel-runtime/regenerator/index.js
// module id = 20
// module chunks = 1